// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Flowchart = function Flowchart(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M13.311 10.353V7.784H8.498V5.648h1.675V1.41H5.937v4.238H7.63v2.136H2.689v2.569H1.004v4.237h4.238v-4.237H3.557V8.652h8.886v1.701h-1.685v4.237h4.238v-4.237h-1.685z"
    }))
  );
};

export default Flowchart;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Flowchart.js
// module id = 1012
// module chunks = 0